import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, BarChartIcon, UsersIcon, FileTextIcon, MessageSquareIcon, SettingsIcon, DollarSignIcon, BookIcon } from 'lucide-react';
export function Sidebar({
  userRole
}) {
  const location = useLocation();
  const isActive = path => {
    return location.pathname === path;
  };
  const navItems = [{
    label: 'Dashboard',
    icon: <HomeIcon size={20} data-id="element-498" />,
    path: userRole === 'admin' ? '/admin' : '/dashboard',
    roles: ['admin', 'employee']
  }, {
    label: 'New Expense',
    icon: <DollarSignIcon size={20} data-id="element-499" />,
    path: '/expense/new',
    roles: ['admin', 'employee']
  }, {
    label: 'Knowledge Base',
    icon: <BookIcon size={20} data-id="element-500" />,
    path: '/knowledge-base',
    roles: ['admin', 'employee']
  }, {
    label: 'Employees',
    icon: <UsersIcon size={20} data-id="element-501" />,
    path: '/employees',
    roles: ['admin']
  }, {
    label: 'Settings',
    icon: <SettingsIcon size={20} data-id="element-502" />,
    path: '/settings',
    roles: ['admin']
  }];
  const filteredNavItems = navItems.filter(item => item.roles.includes(userRole));
  return <aside className="w-64 bg-gray-800 border-r border-gray-700 h-full flex flex-col shadow-sm" data-id="element-503">
      <div className="p-6 border-b border-gray-700" data-id="element-504">
        <div className="flex items-center" data-id="element-505">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i6oVrqgB5xjeK1sZqzAiqJ/Sprinklenet_Logo_Black_with_Transparent_Background.png" alt="Sprinklenet Logo" className="h-8 invert" // Invert the logo to make it white
        data-id="element-506" />
        </div>
      </div>
      <nav className="flex-1 px-4 py-4" data-id="element-507">
        <ul className="space-y-1" data-id="element-508">
          {filteredNavItems.map((item, index) => <li key={index} data-id="element-509">
              <Link to={item.path} className={`flex items-center px-4 py-3 rounded-lg text-sm transition-colors ${isActive(item.path) ? 'bg-gray-700 text-blue-300 font-medium' : 'text-gray-300 hover:bg-gray-700 hover:text-gray-100'}`} data-id="element-510">
                <span className="mr-3" data-id="element-511">{item.icon}</span>
                {item.label}
              </Link>
            </li>)}
        </ul>
      </nav>
      <div className="p-4 border-t border-gray-700" data-id="element-512">
        <div className="bg-gray-700 p-4 rounded-lg" data-id="element-513">
          <h4 className="text-sm font-medium text-blue-300" data-id="element-514">Need Help?</h4>
          <p className="text-xs text-gray-300 mt-1" data-id="element-515">
            Have a question about your expenses or per diem rates?
          </p>
          <Link to="/knowledge-base" className="mt-2 text-xs font-medium text-blue-300 hover:text-blue-200 transition-colors flex items-center" data-id="element-516">
            Visit Knowledge Base
            <BookIcon size={12} className="ml-1" data-id="element-517" />
          </Link>
        </div>
      </div>
    </aside>;
}